import { Box } from '@wix/design-system';
import { isTextHebrew } from '@wix/wix-chatbot-common/locale';
import React, { FC } from 'react';

import { classNames } from '../../../../util';
import { Button } from '../../../common/components/Button';
import { IIntentItem, IIntentSelector } from '../../../common/messageCreators/intentSelector';
import { useUserActionClickSelector } from '../../hooks';
import { MessageItem } from '../MessageItem';
import s from './IntentSelector.scss';

/**
 * @deprecated and never going to be used, but should be cleaned up with the rest of the server logic
 * including removing message type MESSAGES.INTENT_SELECTOR
 */
export const IntentSelector: FC<IIntentSelector> = ({ id, type, items }) => {
  const emit = useUserActionClickSelector();

  const onClick = (item: IIntentItem, position: number) => {
    emit(type, {
      position,
      label: item.title,
      item,
    });
  };

  const buttons = items.map((item, i) => {
    const isTextButton = !item.intent;
    return (
      <div key={item.title} className={s.item} role="listitem">
        <Button
          className={isTextButton ? s.textButton : undefined}
          blank={isTextButton}
          secondary={!isTextButton}
          onClick={() => onClick(item, i)}
          data-hook="item"
        >
          <span data-hook="label" className={classNames([isTextHebrew(item.title) && s.rtlButton])}>
            {item.title}
          </span>
        </Button>
      </div>
    );
  });

  return (
    <MessageItem id={id}>
      <div className={s.list} role="list">
        <Box direction="vertical">{buttons}</Box>
      </div>
    </MessageItem>
  );
};
